import React from 'react'
import LeftSideBar from '../../../Components/Common/LeftSideBar'
import Footer from '../../../Components/Common/Footer'
import TopBar from '../../../Components/Common/TopBar'
import PageHeader from '../../../Components/Common/PageHeader'
import functions from '../../../utils/functions'
import RightSideBar from '../../../Components/Common/RightSideBar'
import ConfigMenu from '../../../Components/ConfigMenu'
import ajax from '../../../utils/ajax'
// import ActivityLoader from '../../../Components/Common/ActivityLoader'
import TextInput from '../../../Components/Common/TextInput'
import dictionary from '../../../utils/dictionary'
import AlertSuccess from '../../../Components/Common/AlertSuccess'
import AlertError from '../../../Components/Common/AlertError'

class UpdateBranch extends React.Component {

  state = {
    userId: functions.sessionGuard(),
    branchName: '',
    branchId: '',
    lat: '',
    lng: '',
    info: ''
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push('/config/branches');
    } else {
      const branchRecord = this.props.location.state.record;
      this.setState({
        branchName: branchRecord.branch_name,
        branchId: branchRecord.branch_id,
        lat: branchRecord.lat,
        lng: branchRecord.lng
      })
    }
  }


  onChangeBranchName = (event) => {
    this.setState({ branchName: event.target.value })
  }

  onChangeLat = (event) => {
    this.setState({ lat: event.target.value })
  }

  onChangeLng = (event) => {
    this.setState({ lng: event.target.value })
  }

  onSave = async (event) => {
    event.preventDefault();
    const { branchName, lat, lng, branchId } = this.state;
    if (branchName.length > 0 && branchId.length > 0) {
      //fetch login from the API
      const server_response = await ajax.updateBranch(branchId, branchName, lat, lng);
      if (server_response.status === "OK") {
        this.setState({
          info: <AlertSuccess message={server_response.details.message} />
        })

      } else {

        this.setState({
          info: <AlertError message={server_response.details.message} />
        })

      }

    } else {
      this.setState({
        info: <AlertError message={dictionary._requireBranchName} />,
        loading: ''
      })
    }


  }

  render() {
    return (
      <div className="page">
        <LeftSideBar />
        <div className="main-content side-content pt-0" onClick={functions.closeSystemDrawer}>
          <TopBar />
          <div className="container-fluid">
            <PageHeader
              title="Edit Branch"
              previousPageTitle="Branches"
              back="/config/branches"
            />

            <div className="row">
              <div className="col-xl-9 col-lg-12">
                <div className="row">

                  <div className="col-sm-12 col-xl-12 col-lg-12">
                    <div className="card custom-card">
                      <div className="card-body">
                        {this.state.info}
                        <form method="post" onSubmit={this.onSave}>


                          <TextInput
                            label="Branch Name"
                            type="text"
                            onChange={() => this.onChangeBranchName}
                            value={this.state.branchName}
                          />

                          <TextInput
                            label="Geo Latitude"
                            type="number"
                            onChange={() => this.onChangeLat}
                            value={this.state.lat}
                          />

                          <TextInput
                            label="Geo Longitude"
                            type="number"
                            onChange={() => this.onChangeLng}
                            value={this.state.lng}
                          />


                          <div className="modal-footer">
                            <input className="btn ripple btn-success" type="button" value="Save Changes" onClick={this.onSave} />
                          </div>
                        </form>


                      </div>
                    </div>


                  </div>



                </div>

              </div>

              <ConfigMenu />



            </div>



          </div>
        </div>
        <RightSideBar />
         
      </div>


    );

  }
}

export default UpdateBranch
